<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <span class="d-flex align-items-center">
        <span>Sponsorships and Nominations</span>
        <button mat-stroked-button (click)="refresh()" class="icon-only m-l-05" aria-label="Refresh">
          <mat-icon>refresh</mat-icon>
        </button>
      </span>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <mat-card-actions class="filters flex-gap-05">
      <mat-form-field appearance="outline" class="search-filter">
        <mat-label>Search</mat-label>
        <input matInput placeholder="Search" [formControl]="search" />
        @if (search.value) {
          <mat-icon matSuffix (click)="clearSearch()" class="cursor-pointer" title="Clear search text">close</mat-icon>
        }
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="status-filter">
        <mat-label>Status</mat-label>
        <mat-select [formControl]="statusFilter" multiple>
          @for (s of statuses(); track s) {
            <mat-option [value]="s">{{ s }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-card-actions>

    @if (loading()) {
      <div class="d-flex justify-content-center">
        <mat-spinner></mat-spinner>
      </div>
    }

    @if (!loading() && pagedNominations(); as pagedNominations) {
      <div class="nominations-scroll">
        <table mat-table [dataSource]="pagedNominations.items">
          
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let element">{{ element.entryTypeText }}</td>
          </ng-container>

          <ng-container matColumnDef="nominee">
            <th mat-header-cell *matHeaderCellDef>Nominee</th>
            <td mat-cell *matCellDef="let element">{{ element.nomineeName || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef>Position</th>
            <td mat-cell *matCellDef="let element">{{ element.positionTitle || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="lodged">
            <th mat-header-cell *matHeaderCellDef>Lodged</th>
            <td mat-cell *matCellDef="let element">{{ element.lodgementDate ? (element.lodgementDate | dateTimeFromIso | dateTimeToFormat: 'dd MMM yyyy') : '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="decided">
            <th mat-header-cell *matHeaderCellDef>Decided</th>
            <td mat-cell *matCellDef="let element">{{ element.decisionDate ? (element.decisionDate | dateTimeFromIso | dateTimeToFormat: 'dd MMM yyyy') : '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
              <span class="d-flex align-items-center">
                <mat-icon [ngClass]="getStatusClass(element)" fontSet="material-symbols-outlined">{{ getStatusIcon(element) }}</mat-icon>
                <span class="m-l-05">{{ element.status }}</span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="link">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"><mat-icon>chevron_right</mat-icon></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openDetail(row)"></tr>
        </table>
      </div>

      <mat-paginator
        [length]="pagedNominations.totalCount"
        [pageSize]="pagedNominations.pageSize"
        [pageIndex]="pagedNominations.pageNumber - 1"
        [pageSizeOptions]="[5, 10, 25]"
        showFirstLastButtons
        aria-label="Select page of Nominations"
        [hidden]="pagedNominations.items.length === 0"
        (page)="handlePageEvent($event)">
      </mat-paginator>

      <div class="text-align-center m-t-1" *ngIf="pagedNominations.items.length === 0">There are currently no nominations here.</div>
    }
  </mat-card-content>
</mat-card>
